import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import firebase from "firebase/app";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CategoriesList from "../../components/categories/CategoriesList";
import StoreImage from "../../components/StoreImage";
import { algoliaClient } from "../../utils/constants";
import { useTheme } from "@mui/material/styles";
import CompareStoreItem from "../../components/compare/compareStoreItem";
import EmptyComponentRender from "../../components/EmptyComponentRender";
import Carousel from "react-material-ui-carousel";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { toast as Toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faPlusCircle,
  faBalanceScaleRight,
  faChevronUp,
  faChevronDown,
  faHeart,
  faBell,
} from "@fortawesome/free-solid-svg-icons";
import {
  faHeart as faHeartNotFilled,
  faBell as faBellNotFilled,
} from "@fortawesome/free-regular-svg-icons";
import Skeleton from "@mui/material/Skeleton";
import { makeStyles } from "@mui/styles/";
import Typography from "@mui/material/Typography";
import { addItemToCart } from "../../redux/reducers/cart.reducer";
import { setFavouriteProducts } from "../../redux/reducers/favouriteProducts.reducer";
import { setNotificationsProducts } from "../../redux/reducers/notificationsProducts.reducer";
import { isMobile } from "react-device-detect";
import { CircularProgress } from "@mui/material";
const useStyles = makeStyles({
  headerTitle: {
    fontSize: 18,
  },
  actions: {
    marginTop: -30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    flexDirection: "row",
    paddingTop: 8,
    height: 50,
    width: 50,
  },
  detailsView: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 14,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: "#dfe4fe",
  },
  productTitleView: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: 10,
    paddingRight: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  headerTitleView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  productTitle: {
    textAlign: "center",
    marginTop: 20,
  },
  productPriceView: {
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  actualPriceText: { color: "green", fontWeight: "bold", fontSize: 15 },
  discountExpText: {
    marginLeft: 10,
    color: "gray",
    fontWeight: "400",
    fontSize: 12,
  },
  discountedPriceText: {
    // color: "#222",
    color: "red",
    marginLeft: 10,
    textDecorationLine: "line-through",
    fontSize: 11,
  },
  addToCart: {
    borderRadius: 25,
    width: 40,
    height: 40,
  },
  imagesList: {
    elevation: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: isMobile ? "row" : "column",
    height: "100%",
    width: "100%",
  },
  storeText: {
    fontWeight: "bold",
    marginLeft: 10,
    textDecorationLine: "underline",
    fontSize: 16,
  },
  details: {
    marginTop: 0,
    marginBottom: 0,
  },
  addToCartButton: {
    flex: 1,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#fff",
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 6,
    borderWidth: 1,
    borderColor: "#111",
  },
  productDescriptionHeader: {
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#dfe4fe",
  },
  centerElement: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  filterButton: { padding: 10, bottom: 10, elevation: 10, borderRadius: 20 },
  productItemCounterView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  counterValue: {
    fontSize: 20,
    marginInline: 10,
    fontWeight: "500",
  },
  toggleCounterButton: {
    paddingLeft: 20,
    paddingRight: 20,
    fontSize: 20,
  },
  itemCard: {
    borderBottomWidth: 1,
    borderRadius: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100%",
    paddingTop: 5,
    paddingBottom: 5,
    marginTop: 5,
    marginBottom: 5,
  },
  filtersContener: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
  },
});
const productsIndex = algoliaClient.initIndex("products");
const ProductScreen = ({}) => {
  const [lowestSize, setLowestSize] = useState(false);
  const [lowestBrand, setLowestBrand] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchMode, setSearchMode] = React.useState(false);
  const [searchRecords, setSearchRecords] = React.useState([]);
  const [cartLoading, setCartLoading] = useState(false);
  const [productDescription, setProductDescription] = useState("");
  const [discountDuoTo, setDiscountDuoTo] = useState();
  const [seeFullDescription, setSeeFullDescription] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const { t, i18n } = useTranslation();
  const [quantity, setQuantity] = useState(0);
  const [recommendedProducts, setRecommendedProducts] = React.useState([]);
  const [product, setProduct] = React.useState(null);
  const products = useSelector((state) => state.cart.products);
  const userData = useSelector((state) => state.auth.user);
  const [categories, setCategories] = React.useState([]);
  const styles = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const params = useParams();
  const dispatch = useDispatch();
  const userFavProducts = useSelector(
    (state) => state.favouriteProducts.products
  );
  const userNotificationProducts = useSelector(
    (state) => state.notificationsProducts.notificationsProducts
  );
  const [isNotificatiosEnabled, setIsNotificatiosEnabled] = useState(
    params?.id ? userNotificationProducts?.includes(params.id) : false
  );
  const [isFavourite, setFavourite] = useState(
    params?.id ? userFavProducts?.includes(params.id) : false
  );
  React.useEffect(() => {
    console.log("Params: ", params);
    if (params && params.id) {
      loadProduct(params.id);
    }
  }, [params]);

  const loadProduct = (id) => {
    setLoading(true);
    firebase
      .firestore()
      .collection("products")
      .doc(id)
      .get()
      .then((result) => {
        const dataRef = result.data();
        let data = {
          ...dataRef,
          createdAt: dataRef.createdAt.toDate(),
          currentDiscountExpiry: dataRef.currentDiscountExpiry
            ? dataRef.currentDiscountExpiry.toDate()
            : dataRef.currentDiscountExpiry,
        };
        if (data.discount && Number(data.discount) > 0) {
          const priceAfterDiscount =
            data.price - data.price * (Number(data.discount) / 100);
          setProduct({ priceAfterDiscount: priceAfterDiscount, ...data });
          if (
            data.currentDiscountExpiry &&
            data.currentDiscountExpiry != null
          ) {
            const exp = data.currentDiscountExpiry;
            const isValid = moment(new Date()).isSameOrBefore(exp);
            const diff = moment().diff(exp, "days");

            console.log("isAfter : ", isValid);
            console.log("diff : ", diff);
            if (isValid && diff * -1 <= 10) {
              setDiscountDuoTo(diff);
            }
            if (!isValid) {
              setProduct({ priceAfterDiscount: data.price, ...data });
            }
          }
        } else {
          setProduct(data);
        }
        setProductDescription(data.description);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error getting product  : ", err);
      });
  };

  const handleLowestSizeChange = () => {
    setLowestSize(!lowestSize);
  };

  const handleLowestBrandChange = () => {
    setLowestBrand(!lowestBrand);
  };

  const handleFavouriteChange = async () => {
    if (params.id) {
      if (
        userFavProducts &&
        userFavProducts.length > 0 &&
        userFavProducts.includes(params.id)
      ) {
        setFavourite(false);
        let favList =
          userFavProducts.filter((productId) => productId != params.id) ?? [];
        dispatch(setFavouriteProducts(favList));
        if (userData && userData.id && !userData?.isAnonymous) {
          await firebase
            .firestore()
            .collection("users")
            .doc(userData.id)
            .update({ favourites: favList });
        }
        //await updateUserInfo({ ...userInfo, favourites: favList });
      } else {
        setFavourite(true);
        let favList = [...userFavProducts];
        favList.push(params.id);
        dispatch(setFavouriteProducts(favList));
        if (userData && userData.id && !userData?.isAnonymous) {
          await firebase
            .firestore()
            .collection("users")
            .doc(userData.id)
            .update({ favourites: favList });
        }
        //await updateUserInfo({ ...userInfo, favourites: favList });
      }
    }
  };
  const handleNotificationChange = async () => {
    if (params.id && !userData?.isAnonymous) {
      if (
        userNotificationProducts &&
        userNotificationProducts.length > 0 &&
        userNotificationProducts.includes(params.id)
      ) {
        setIsNotificatiosEnabled(false);
        let notificationList =
          userNotificationProducts.filter(
            (productId) => productId != params.id
          ) ?? [];
        dispatch(setNotificationsProducts(notificationList));
        if (userData && userData.id) {
          await firebase
            .firestore()
            .collection("users")
            .doc(userData.id)
            .update({ notifications: notificationList });
        }
        //await updateUserInfo({ ...userInfo, favourites: favList });
      } else {
        setIsNotificatiosEnabled(true);
        let notificationList = [...userNotificationProducts];
        notificationList.push(params.id);
        dispatch(setNotificationsProducts(notificationList));
        if (userData && userData.id) {
          await firebase
            .firestore()
            .collection("users")
            .doc(userData.id)
            .update({ notifications: notificationList });
        }
        //await updateUserInfo({ ...userInfo, favourites: favList });
      }
    } else if (userData?.isAnonymous) {
      Toast.error(`Oops!! ${t("users.loginAsNormalUser")}`);
    }
  };

  const handleAddItemToCart = async (product) => {
    if (quantity > 0) {
      setCartLoading(true);
      const productDateStringified = {
        id: product.id,
        cartQuantity: quantity,
        createdAt: product.createdAt.getTime(),
        currentDiscountExpiry:
          product.currentDiscountExpiry && product.currentDiscountExpiry.getTime
            ? product.currentDiscountExpiry.getTime()
            : product.currentDiscountExpiry,
      };
      await firebase
        .firestore()
        .collection("users")
        .doc(userData?.id)
        .set(
          {
            ...userData,
            cart: {
              products: [...products, productDateStringified],
              count: products?.length + 1 ?? 0,
            },
          },
          { merge: true }
        );
      dispatch(addItemToCart(productDateStringified));
      setCartLoading(false);
      Toast.success("Added Item To Comparing Cart", {
        visibilityTime: 1500,
      });
    } else {
      Toast.error(t("product.quantity-validation"), {
        visibilityTime: 3000,
      });
    }
  };

  const filterCompare = (options) => {
    //const storesSearch = stores && stores.length > 0 ? stores.map(storeId => `store:${storeId}` ):[];
    productsIndex
      .search("", {
        //"facetFilters": [...options,storesSearch],
        facetFilters: [...options],
        facets: ["*"],
      })
      .then((results) => {
        setSearchRecords(results.hits);
        setLoading(false);
      })
      .catch((err) => {
        Toast.error(
          "Could not retrieve any search records, Please try again later."
        );
        setLoading(false);
      });
  };
  const loadDataFromAlgolia = (product) => {
    setLoading(true);
    if (lowestSize && lowestBrand) {
      filterCompare([
        [`category:${product.category}`],
        [`brand:${product.brand}`],
        [`sizeOrCapacity:${product.sizeOrCapacity}`],
        [`measureUnit:${product.measureUnit}`],
      ]);
    } else if (lowestSize && !lowestBrand) {
      filterCompare([
        [`category:${product.category}`],
        [`sizeOrCapacity:${product.sizeOrCapacity}`],
        [`measureUnit:${product.measureUnit}`],
      ]);
    } else if (!lowestSize && lowestBrand) {
      filterCompare([
        [`category:${product.category}`],
        [`brand:${product.brand}`],
      ]);
    } else {
      filterCompare([[`category:${product.category}`]]);
    }
  };

  React.useEffect(() => {
    if (product) {
      loadDataFromAlgolia(product);
    }
  }, [product, lowestBrand, lowestSize]);
  return (
    <main>
      {product && (
        <Container sx={{ py: 2 }} maxWidth="lg">
          {loading ? (
            <Box sx={{ pt: 0.5 }}>
              <Skeleton variant="rectangular" width={"100%"} height={"60%"} />
              <Skeleton />
              <Skeleton width="60%" />
            </Box>
          ) : (
            <Grid container spacing={8}>
              <Grid item container xs={12} sm={12}>
                <Paper
                  elevation={5}
                  style={{
                    height: "100%",
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 15,
                    padding: isMobile ? 5 : 20,
                  }}
                >
                  <Grid container spacing={isMobile ? 5 : 3}>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      style={{
                        flexDirection: isMobile ? "row" : "column",
                        marginTop: 15,
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          flexDirection: isMobile ? "row" : "column",
                          width: "100%",
                        }}
                      >
                        <Carousel
                          className={styles.imagesList}
                          navButtonsAlwaysVisible={true}
                          autoPlay={false}
                          activeIndicatorIconButtonProps={{
                            style: {
                              backgroundColor: theme.light.primary,
                              color: theme.light.primary,
                            },
                          }}
                          swipe={true}
                          navButtonsProps={{
                            style: {
                              backgroundColor: theme.light.primary,
                            },
                          }}
                          indicators={true}
                          sx={{
                            justifyContent: "center",
                            display: "flex",
                            flexDirection: "column",
                            paddingBottom: 2,
                          }}
                        >
                          {product?.images.map((item, i) => (
                            <div
                              style={{
                                justifyContent: "center",
                                height: "100%",
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <img
                                height={"100%"}
                                width={"100%"}
                                key={"product image home page " + i}
                                sx={{
                                  height: "100%",
                                  width: "100%",
                                  alignSelf: "center",
                                  resizeMode: "contain",
                                  objectFit: "contain",
                                }}
                                src={item}
                                alt="random"
                              />
                            </div>
                          ))}
                        </Carousel>
                      </div>
                    </Grid>
                    <Grid item container xs={12} sm={8}>
                      <div
                        style={{
                          height: "50%",
                          width: "100%",
                          maxHeight: "50%",
                          flexDirection: "column",
                          marginTop: 15,
                          padding: isMobile ? 5 : 20,
                        }}
                      >
                        <div className={styles.headerTitleView}>
                          <Typography
                            style={{
                              marginInline: 30,
                              fontSize: 28,
                              alignSelf: "center",
                            }}
                            className={styles.productTitle}
                          >
                            {
                              product[
                                i18n.language == "ar" ? "titleAr" : "titleEn"
                              ]
                            }
                          </Typography>
                          <div
                            onClick={() => handleFavouriteChange()}
                            style={{
                              marginTop: -30,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              alignSelf: "flex-end",
                              flexDirection: "row",
                              cursor: "pointer",
                              paddingTop: 8,

                              height: 50,
                              width: 50,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={isFavourite ? faHeart : faHeartNotFilled}
                              style={{
                                fontSize: 35,
                                color: theme.light.primary,
                              }}
                            />
                          </div>
                          {/* //////////////////// */}
                          {!userData.isAnonymous && (
                            <div
                              onClick={() => handleNotificationChange()}
                              style={{
                                marginTop: -30,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                alignSelf: "flex-end",
                                flexDirection: "row",
                                cursor: "pointer",
                                paddingTop: 8,
                                marginLeft: 10,
                                height: 50,
                                width: 50,
                              }}
                            >
                              <FontAwesomeIcon
                                icon={
                                  isNotificatiosEnabled
                                    ? faBell
                                    : faBellNotFilled
                                }
                                style={{
                                  fontSize: 35,
                                  color: theme.light.primary,
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className={styles.productTitleView}>
                          <Typography
                            style={{
                              letterSpacing: 2,
                              marginTop: 10,
                              fontSize: 18,
                              fontWeight: "400",
                              color: "gray",
                            }}
                          >
                            {`${product.sizeOrCapacity ?? ""} ${
                              product.measureUnit ?? ""
                            } ${" , "}`}
                          </Typography>
                          <Typography
                            style={{
                              letterSpacing: 2,
                              marginTop: 10,
                              fontSize: 18,
                              fontWeight: "400",
                              color: "gray",
                            }}
                          >
                            {`${product.brand ?? ""} , ${
                              product.categoryInfo[
                                i18n.language == "ar" ? "titleAr" : "titleEn"
                              ] ?? ""
                            }`}
                          </Typography>
                        </div>
                        <div className={styles.detailsView}>
                          <div
                            style={{
                              marginTop: 30,
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignSelf: "center",
                              }}
                            >
                              {!!product.storeInfo && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignSelf: "center",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <StoreImage
                                    storeID={product.store}
                                    image={product.storeInfo.image ?? ""}
                                  />
                                </div>
                              )}
                              <div
                                style={{
                                  marginLeft: 25,
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-start",
                                  alignSelf: "center",
                                }}
                              >
                                <Typography
                                  style={{
                                    textAlign: "center",
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                  }}
                                  className={styles.actualPriceText}
                                >
                                  {t("product.currency")}{" "}
                                  {Number(
                                    !product.priceAfterDiscount
                                      ? product.price *
                                          (quantity > 0 ? quantity : 1)
                                      : product.priceAfterDiscount *
                                          (quantity > 0 ? quantity : 1)
                                  ).toFixed(2)}{" "}
                                </Typography>
                                {!!product.discount &&
                                  Number(product.discount) > 0 &&
                                  !!product.priceAfterDiscount &&
                                  !!discountDuoTo && (
                                    <Typography
                                      style={{
                                        textAlign: "center",
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                      }}
                                      className={styles.discountedPriceText}
                                    >
                                      {t("product.currency")}{" "}
                                      {Number(
                                        product.price *
                                          (quantity > 0 ? quantity : 1)
                                      ).toFixed(2)}
                                    </Typography>
                                  )}
                                {!!product.discount &&
                                  Number(product.discount) > 0 &&
                                  !!product.priceAfterDiscount &&
                                  !!discountDuoTo &&
                                  discountDuoTo * -1 <= 10 && (
                                    <Typography
                                      style={{
                                        textAlign: "center",
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                      }}
                                      className={styles.discountExpText}
                                    >
                                      {t("product.expire").replace(
                                        "{days}",
                                        discountDuoTo * -1
                                      )}{" "}
                                    </Typography>
                                  )}
                              </div>
                            </div>
                            {!cartLoading ? (
                              <Button
                                style={{
                                  display: "flex",
                                  alignSelf: "center",
                                  right: 0,
                                  color: "whitesmoke",
                                  backgroundColor: "#774e1e",
                                }}
                                onClick={() => handleAddItemToCart(product)}
                                disabled={cartLoading}
                                variant="contained"
                              >
                                {t("product.addToCart")}
                              </Button>
                            ) : (
                              <Button
                                style={{
                                  display: "flex",
                                  alignSelf: "center",
                                  right: 0,
                                }}
                                onClick={() => {}}
                                disabled={true}
                                variant="contained"
                              >
                                {t("general.addingToCart")}
                              </Button>
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              marginTop: 30,
                            }}
                          >
                            <div
                              className={[
                                styles.centerElement,
                                styles.filterButton,
                              ].join(" ")}
                              style={{
                                alignSelf: "flex-start",
                                backgroundColor: lowestSize
                                  ? theme.light.primary
                                  : "grey",
                                elevation: 10,
                                opacity: 1,
                              }}
                              onClick={handleLowestSizeChange}
                            >
                              <FontAwesomeIcon
                                icon={faBalanceScaleRight}
                                size={14}
                                color={"#fff"}
                              />
                              <Typography
                                style={{ color: "#fff", fontSize: 15 }}
                              >
                                {" " + t("compare.lowestSize")}
                              </Typography>
                            </div>
                            <div
                              style={{
                                dispaly: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignSelf: "center",
                              }}
                              className={styles.productItemCounterView}
                            >
                              <div
                                disabled={quantity === 1}
                                style={{
                                  dispaly: "flex",
                                  alignSelf: "center",
                                  marginInline: isMobile ? 4 : 10,
                                }}
                                onClick={() => {
                                  if (quantity > 0) {
                                    setQuantity(quantity - 1);
                                  }
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faMinusCircle}
                                  className={styles.toggleCounterButton}
                                />
                              </div>
                              <Typography className={styles.counterValue}>
                                {quantity}
                              </Typography>
                              <div
                                style={{
                                  dispaly: "flex",
                                  alignSelf: "center",
                                  marginInline: isMobile ? 5 : 10,
                                }}
                                onClick={() => {
                                  setQuantity(quantity + 1);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faPlusCircle}
                                  className={styles.toggleCounterButton}
                                />
                              </div>
                            </div>
                            <div
                              className={[
                                styles.centerElement,
                                styles.filterButton,
                              ].join(" ")}
                              style={{
                                alignSelf: "flex-end",
                                backgroundColor: lowestBrand
                                  ? theme.light.primary
                                  : "grey",
                                elevation: 10,
                                opacity: 1,
                              }}
                              onClick={handleLowestBrandChange}
                            >
                              <FontAwesomeIcon
                                icon={faBalanceScaleRight}
                                size={14}
                                color={"#fff"}
                              />
                              <Typography
                                style={{ color: "#fff", fontSize: 15 }}
                              >
                                {" " + t("compare.lowestBrand")}
                              </Typography>
                            </div>
                          </div>
                        </div>
                        <div style={{ backgroundColor: "#fff" }}>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setSeeFullDescription((prev) => !prev)
                            }
                          >
                            <div
                              className={styles.productDescriptionHeader}
                              style={{
                                marginTop: 15,
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                borderBlockWidth: 0.5,
                                borderBlockStyle: "solid",
                                borderBlockColor: "ActiveBorder",
                              }}
                              onClick={() =>
                                setSeeFullDescription((prev) => !prev)
                              }
                            >
                              <Typography
                                style={{
                                  flexDirection: "column",
                                  fontSize: 18,
                                }}
                              >
                                {t("product.description")}
                              </Typography>
                              <div
                                style={{
                                  cursor: "pointer",
                                  flexDirection: "column",
                                  marginInline: 10,
                                }}
                                onClick={() =>
                                  setSeeFullDescription((prev) => !prev)
                                }
                              >
                                {seeFullDescription ? (
                                  <FontAwesomeIcon
                                    icon={faChevronUp}
                                    size={26}
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faChevronDown}
                                    size={26}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          {seeFullDescription && (
                            <div
                              style={{ paddingHorizontal: 10, paddingTop: 10 }}
                            >
                              <Typography>
                                {seeFullDescription
                                  ? `${productDescription}`
                                  : ``}
                              </Typography>
                            </div>
                          )}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item container xs={12} sm={12}>
                <Paper
                  elevation={5}
                  style={{
                    height: "100%",
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 15,
                    padding: isMobile ? 5 : 20,
                  }}
                >
                  <Grid container spacing={5}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      style={{ flexDirection: "row", justifyContent: "center" }}
                      className={styles.productDescriptionHeader}
                    >
                      <Typography
                        style={{
                          textAlign: "center",
                          fontSize: 28,
                          alignSelf: "center",
                        }}
                      >
                        {t("compare.compare-results")}
                        <FontAwesomeIcon
                          style={{ marginRight: 10, marginLeft: 10 }}
                          size={20}
                          icon={faBalanceScaleRight}
                        />
                      </Typography>
                    </Grid>
                    {!!searchRecords && searchRecords.length > 0 ? (
                      searchRecords
                        .sort((a, b) => {
                          const priceAfterDiscountItemA =
                            !!a.discount && Number(a.discount) > 0
                              ? a.price - a.price * (Number(a.discount) / 100)
                              : a.price;
                          const priceAfterDiscountItemB =
                            !!b.discount && Number(b.discount) > 0
                              ? b.price - b.price * (Number(b.discount) / 100)
                              : b.price;
                          return (
                            priceAfterDiscountItemA - priceAfterDiscountItemB
                          );
                        })
                        .map((item, index) => (
                          <Grid style={{ cursor: "pointer" }} item xs={12}>
                            <Paper
                              style={{
                                borderBottomWidth: 1,
                                borderRadius: 10,
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-around",
                                alignItems: "center",
                                width: "100%",
                                paddingVertical: 5,
                                paddingBottom: 5,
                                marginVertical: 5,
                              }}
                              elevation={5}
                            >
                              <CompareStoreItem
                                key={index}
                                productItem={item}
                              />
                            </Paper>
                          </Grid>
                        ))
                    ) : !loading ? (
                      <Grid item xs={12} sm={12}>
                        <EmptyComponentRender />
                      </Grid>
                    ) : null}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          )}
        </Container>
      )}
    </main>
  );
};

export default ProductScreen;
